

import { Box, Typography } from '@mui/material';

export function TierProgress({ currentTier, qualifiedEventCount }) {
    const tiers = [
        { name: 'Newbie', min: 0, max: 3 },
        { name: 'Rising Star', min: 4, max: 10 },
        { name: 'Pro', min: 11, max: 20 },
        { name: 'Master', min: 21, max: 50 },
        { name: 'Legendary', min: 51, max: Infinity }
    ];

    const currentTierIndex = tiers.findIndex(t => t.name === currentTier);
    const totalProgress = Math.min(qualifiedEventCount, 51);

    return (
        <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
                Host Tier Progress
            </Typography>

            <Box sx={{ position: 'relative', height: 16, background: '#eee', borderRadius: 8, mb: 1 }}>
                <Box
                    sx={{
                        width: `${(totalProgress / 51) * 100}%`,
                        height: '100%',
                        background: '#f09637',
                        borderRadius: 8,
                        transition: 'width 0.3s ease'
                    }}
                />
                {tiers.map((tier, index) => (
                    <Box
                        key={tier.name}
                        sx={{
                            position: 'absolute',
                            left: `${(tier.min / 51) * 100}%`,
                            top: '50%',
                            transform: 'translateX(-50%) translateY(-50%)',
                            width: 12,
                            height: 12,
                            backgroundColor: index === currentTierIndex ? '#f09637' : '#aaa',
                            borderRadius: '50%',
                            border: '2px solid white',
                            zIndex: 2
                        }}
                    />
                ))}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: '#666' }}>
                {tiers.map((tier, index) => (
                    <Typography key={tier.name} fontWeight={index === currentTierIndex ? 600 : 400}>
                        {tier.name}
                    </Typography>
                ))}
            </Box>

            <Typography variant="body2" sx={{ mt: 1, color: '#444' }}>
                Qualified Events: <strong>{qualifiedEventCount}</strong> / 51
            </Typography>
        </Box>
    );
}

export function SuggestionsBlock({ suggestions }) {
    if (!suggestions?.length) return null;

    return (
        <div style={{ marginTop: 24 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                💡 Suggestions for This Event
            </Typography>
            <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                {suggestions.map((tip, index) => (
                    <li key={index} style={{ marginBottom: 8 }}>
                        <Typography variant="body2" sx={{ color: '#555' }}>
                            {tip}
                        </Typography>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export function NudgesBlock({ nudges }) {
    if (!nudges?.length) return null;

    return (
        <div style={{ marginTop: 24 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                💬 Personalized Nudges
            </Typography>
            <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
                {nudges.map((nudge, index) => (
                    <li key={index} style={{ marginBottom: 8 }}>
                        <Typography variant="body2" sx={{ color: '#5a4a3f' }}>
                            {nudge}
                        </Typography>
                    </li>
                ))}
            </ul>
        </div>
    );
}